// Modal.jsx
// Client: vmfive
// Version: 1.1.0
// Overlay modal dialog with header, body, footer slots

import React, { useEffect, useRef } from 'react';
import './Modal.css';

export default function Modal({
  title,
  children,
  footer,
  onClose,
  size = 'md',
  className = '',
}) {
  const overlayRef = useRef(null);
  // Track where mousedown started to prevent drag-out accidental close
  const mousedownTargetRef = useRef(null);

  // Close on Escape
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape' && onClose) onClose();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [onClose]);

  // Lock body scroll
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  const handleOverlayMouseDown = (e) => {
    mousedownTargetRef.current = e.target;
  };

  // Only close if BOTH mousedown and mouseup (click) occurred on the backdrop itself.
  // This prevents drag-select inside modal from closing when the user releases
  // the mouse outside the modal content.
  const handleOverlayClick = (e) => {
    if (
      e.target === overlayRef.current &&
      mousedownTargetRef.current === overlayRef.current &&
      onClose
    ) {
      onClose();
    }
    mousedownTargetRef.current = null;
  };

  return (
    <div
      className="modal-overlay"
      ref={overlayRef}
      onMouseDown={handleOverlayMouseDown}
      onClick={handleOverlayClick}
    >
      <div className={`modal modal--${size} ${className}`}>
        {/* Header */}
        <div className="modal__header">
          <h3 className="modal__title">{title}</h3>
          {onClose && (
            <button
              className="modal__close"
              onClick={onClose}
              aria-label="Close"
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 5l10 10M15 5L5 15" />
              </svg>
            </button>
          )}
        </div>

        {/* Body */}
        <div className="modal__body">{children}</div>

        {/* Footer */}
        {footer && <div className="modal__footer">{footer}</div>}
      </div>
    </div>
  );
}
